import { render, staticRenderFns } from "./PayableReceivableConfig.vue?vue&type=template&id=65d8d4c2&"
import script from "./PayableReceivableConfig.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports